function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  // console.log("section.id",element.id.replace("shopify-section-template--", "").replace("__custom_section_recently_viewed_RBGMDc",''))
  return element.id.replace("shopify-section-", "");
}

var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
// js/sections/recently-viewed-products.js

var _isLoaded2, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn;
var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _searchQueryString);
    __privateAdd(this, _loadProducts);
    __privateAdd(this, _isLoaded2, false);
  }
  connectedCallback() {
    __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
  }
};
_isLoaded2 = new WeakMap();
_searchQueryString = new WeakSet();
searchQueryString_get = function() {
  const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
  // console.log('items',items)
  if (this.hasAttribute("data-product-id")) {
    items.delete(parseInt(this.getAttribute("data-product-id")));
  }
  // console.log('items',items)
  return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("data-limit"))).join(" OR ");
};
_loadProducts = new WeakSet();
loadProducts_fn = async function() {

  if (__privateGet(this, _isLoaded2)) {
    // console.log("error")
    return;
  }
  __privateSet(this, _isLoaded2, true);
  const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _searchQueryString, searchQueryString_get)}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
  // console.log('url',url)
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
  // console.log("recentlyViewedProductsElement.childElementCount",recentlyViewedProductsElement.childElementCount,tempDiv)
  if (recentlyViewedProductsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
    // console.log('recentlyViewedProductsElement',recentlyViewedProductsElement)
    $j(recentlyViewedProductsElement).find('.product-card-wrapper').each(function() {
      // console.log('$j(this)', $j(this).attr('js-product-id'),$j(this).attr('js-product-id'))
      var product_id = $j(this).attr('js-product-id')
      var identifier_value = $j(this).attr('js-product-identifier')
      var variant_value = $j(this).attr('js-product-variant-value')
      var product_handle = $j(this).attr('js-product-handle')
      $j(`.custom-selector-wrapper--${product_id} div`).removeClass('loader-selector');
      if (product_id != undefined){
        getProductColorSwatch(identifier,identifier_value,variant_value,product_id,filter_value)
      }
     
    })
  } else {
    // section.remove();
  }
};
if (!window.customElements.get("recently-viewed-products")) {
  // console.log("customElements no get")
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}
// js/sections/recently-viewed-products.js
